import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b331a18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caron-time" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sty" }, null, -1))
const _hoisted_3 = { class: "time-title" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "caron-player" }
const _hoisted_6 = { id: "npp-player" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  className: "btn btn-bg btn-search",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-sousuoleimu" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-zanting" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-bofang1" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-hanhan-01" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-shouqijiantouxiao-copy" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { className: "player" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-shouqijiantouxiao-copy-copy" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { className: "iconfont icon-hanhan-011" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { className: "tip" }
const _hoisted_22 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.caronType) + "（各区域碳通量估算）", 1),
    _withDirectives(_createElementVNode("div", {
      id: `${_ctx.id}caron-chart`,
      class: "line-chart"
    }, null, 8, _hoisted_4), [
      [_vShow, !_ctx.isEmpty]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Dropdown, {
          trigger: ['click'],
          placement: "topLeft"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_Menu, { class: "issue-menu" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carbonTime, (item, index) => {
                  return (_openBlock(), _createBlock(_component_Item, {
                    key: index,
                    onClick: ($event: any) => (_ctx.handleSliderChange(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        (_ctx.isPlay)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              className: "btn btn-bg btn-pause",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePlayer && _ctx.handlePlayer(...args)))
            }, _hoisted_9))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              className: "btn btn-bg btn-play",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePlayer && _ctx.handlePlayer(...args)))
            }, _hoisted_11)),
        _createElementVNode("button", {
          className: "btn btn-both-ends btn-leftest",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSliderChange(0)))
        }, _hoisted_13),
        _createElementVNode("button", {
          className: "btn btn-vcr btn-left",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSliderChange(_ctx.current - 1 < 0 ? 0 : _ctx.current - 1)))
        }, _hoisted_15),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Slider, {
            value: _ctx.current,
            tipFormatter: _ctx.tipFormatter,
            min: 0,
            max: _ctx.max,
            onChange: _ctx.handleSliderChange
          }, null, 8, ["value", "tipFormatter", "max", "onChange"])
        ]),
        _createElementVNode("button", {
          className: "btn btn-vcr btn-right",
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSliderChange(_ctx.current + 1 > _ctx.max ? _ctx.max : _ctx.current + 1)))
        }, _hoisted_18),
        _createElementVNode("button", {
          className: "btn btn-both-ends btn-rightest",
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSliderChange(_ctx.max)))
        }, _hoisted_20),
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.tipFormatter()), 1)
      ])
    ], 512), [
      [_vShow, !_ctx.isEmpty]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
      [_vShow, _ctx.isEmpty]
    ])
  ]))
}